import { ElementType } from '@ritabygglov/core';
import { isDimensionId } from '../../../helpers/dimensionIds';

export const isResizeHandle = (id: string): boolean => {
  return id.includes('resize');
};

export const isRotateHandle = (id: string): boolean => {
  return id.includes('rotate');
};

export const isApexHandle = (id: string): boolean => {
  return id.endsWith('-apex');
};

export const isRadiusHandle = (id: string): boolean => {
  return id.includes('-radius-polyline-');
};

export const extractRadiusPointIndex = (handleId: string): number => {
  return parseInt(handleId.split('-radius-polyline-')[1], 10);
};

export const isSplitHandle = (id: string): boolean => {
  return id.includes('-split-polyline-');
};

export const extractSplitSegmentIndex = (handleId: string): number => {
  return parseInt(handleId.split('-split-polyline-')[1], 10);
};

export const isEditTextHandle = (id: string): boolean => {
  return id.endsWith('-edit-text');
};

export const isDimensionHandle = (id: string): boolean => {
  return isDimensionId(id);
};

export const isContainerElement = (id: string): boolean => {
  return ['container', 'map', 'render-map-canvas'].includes(id);
};

export const isMultiselectBody = (id: string): boolean => {
  return id === 'multiselect-body';
};

export const isBasicElement = (elementType: ElementType): boolean => {
  return [
    ElementType.Rect,
    ElementType.Text,
    ElementType.Symbol,
    ElementType.Fixture,
    ElementType.Triangle,
    ElementType.Trapezoid,
    ElementType.Angle,
  ].includes(elementType);
};

export const isPolylineElement = (elementType: ElementType): boolean => {
  return elementType === ElementType.Polyline;
};

export const extractElementId = (handleId: string): string => {
  if (isResizeHandle(handleId)) {
    return handleId.split('-resize')[0];
  }
  if (isRotateHandle(handleId)) {
    return handleId.split('-rotate')[0];
  }
  if (isApexHandle(handleId)) {
    return handleId.split('-apex')[0];
  }
  if (isEditTextHandle(handleId)) {
    return handleId.split('-edit-text')[0];
  }
  if (isRadiusHandle(handleId)) {
    return handleId.split('-radius')[0];
  }
  if (isSplitHandle(handleId)) {
    return handleId.split('-split')[0];
  }
  return handleId;
};

export const extractResizeElementId = (handleId: string): string => {
  return handleId.split('-resize-')[0];
};
